import { getFileSize } from 'utils/utils';
import useAxios from './Auth/useAxios';

// *** Used for Upload Task, Console, Chat, Cascade Solution Files ***
const FILE_Path = '/lynorg-service/endpoint/filemngt';
const FILE_PathNonMng = '/lynorg-service/endpoint/file';

const useFileHandler = () => {
	const { fileAxios: _axios } = useAxios();

	const downloadFileHandler = async (payload, fileName, api) => {
		try {
			const response = await _axios.post(`${FILE_Path}${api}`, payload, {
				responseType: 'blob',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (response?.status === 200) {
				const url = window.URL.createObjectURL(response.data);
				const a = document.createElement('a');
				a.style.display = 'none';
				a.href = url;
				a.download = fileName;
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
			}

			if (response?.data?.status === 500) {
				throw new Error('Error', { cause: response?.message });
			}
		} catch (error) {
			// console.log(error);
		}
	};

	const getPDFAsBlobURl = async (payload, api) => {
		try {
			const response = await _axios.post(`${FILE_Path}${api}`, payload, {
				responseType: 'blob',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (response?.status === 200) {
				const pdfBlobUrl = URL.createObjectURL(response.data);

				return pdfBlobUrl;
			}

			if (response?.data?.status === 500) {
				throw new Error('Error', { cause: response?.message });
			}
		} catch (error) {
			// console.log(error);
		}
	};

	const uploadFile = async (options, formData, api) => {
		const { headers } = options;

		try {
			const response = await _axios.post(`${FILE_Path}${api}`, formData, headers);

			// console.log(response);
			const payload = {
				ok: true,
				...response.data,
			};

			if (options?.onSuccess) {
				options?.onSuccess(payload, options?.file);
			}

			// console.log('response.data', response.data);

			return response.data;
		} catch (error) {
			// console.log(error);
			if (options?.onError) {
				if (error.response.status === 500) {
					options?.onError(error.response.data);
				} else {
					options?.onError(error);
				}
			}

			return null;
		}
	};

	const getImage = async (fileId, api, context) => {
		try {
			const response = await _axios.get(`${FILE_Path}${api}?fileId=${fileId}&context=${context}`, {
				responseType: 'blob',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (response?.status === 200) {
				const base64 = await new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = () => resolve(reader.result);
					reader.onerror = (err) => reject(err);
					reader.readAsDataURL(response.data);
				});

				return base64;
			}

			if (response?.data?.status === 500) {
				return false;
			}
		} catch (error) {
			// console.log(error);
			return error;
		}
	};

	const deleteFile = async (payload, api) => {
		try {
			const response = await _axios.post(`${FILE_Path}${api}`, payload, {
				headers: {
					'Content-Type': 'application/json',
				},
			});
			// console.log("response", response);
			if (response?.data?.code === '500') {
				return response?.data;
			} else if (response?.data?.code === '200') {
				return response?.data;
			}
		} catch (error) {
			// console.log(error);
		}
	};

	return { downloadFileHandler, uploadFile, getImage, deleteFile, getPDFAsBlobURl };
};
export default useFileHandler;

export const useNonFileMngHandler = () => {
	const { fileAxios: _axios, apiAxios } = useAxios();

	const downloadFileHandler = async (fileName, api) => {
		try {
			const response = await apiAxios.get(api, {
				responseType: 'blob',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (response?.status === 200) {
				const url = window.URL.createObjectURL(response.data);
				const a = document.createElement('a');
				a.style.display = 'none';
				a.href = url;
				a.download = fileName;
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
			}

			if (response?.data?.status === 500) {
				throw new Error('Error', { cause: response?.message });
			}
		} catch (error) {
			// console.error(error);
		}
	};

	const getPDFAsBlobURl = async (payload, api) => {
		try {
			const response = await _axios.post(`${FILE_PathNonMng}/${api}`, payload, {
				responseType: 'blob',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (response?.status === 200) {
				const pdfBlobUrl = URL.createObjectURL(response.data);

				return pdfBlobUrl;
			}

			if (response?.data?.status === 500) {
				throw new Error('Error', { cause: response?.message });
			}
		} catch (error) {
			// console.log(error);
		}
	};

	const uploadFile = async (options, formData, api) => {
		const { headers } = options;

		try {
			const response = await _axios.post(`${FILE_PathNonMng}${api}`, formData, headers);

			let fileName = response?.data?.fileName;
			let filePath = response?.data?.fileURL?.replace('awareness', '');
			let extension = fileName?.split('.')?.pop()?.toLowerCase();

			const URL = filePath + '.' + extension;
			const size = getFileSize(options?.file?.size);

			const payload = {
				ok: true,
				...response.data,
				url: URL,
				fileSize: size,
			};

			if (options?.onSuccess) {
				options?.onSuccess(payload);
			}

			// console.log('response.data', response.data);

			return response.data;
		} catch (error) {
			// console.log(error);
			if (options?.onError) {
				if (error.response.status === 500) {
					options?.onError(error.response.data);
				} else {
					options?.onError(error);
				}
			}

			return null;
		}
	};

	const getImage = async (fileId, api, context) => {
		try {
			const response = await _axios.get(`${FILE_PathNonMng}${api}?fileId=${fileId}&context=${context}`, {
				responseType: 'blob',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (response?.status === 200) {
				const base64 = await new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = () => resolve(reader.result);
					reader.onerror = (err) => reject(err);
					reader.readAsDataURL(response.data);
				});

				return base64;
			}

			if (response?.data?.status === 500) {
				return false;
			}
		} catch (error) {
			// console.log(error);
			return error;
		}
	};

	const deleteFile = async (payload, api) => {
		try {
			const response = await _axios.post(`${FILE_PathNonMng}${api}`, payload, {
				headers: {
					'Content-Type': 'application/json',
				},
			});
			// console.log("response", response);
			if (response?.data?.code === '500') {
				return response?.data;
			} else if (response?.data?.code === '200') {
				return response?.data;
			}
		} catch (error) {
			// console.log(error);
		}
	};

	return { downloadFileHandler, uploadFile, getImage, deleteFile, getPDFAsBlobURl };
};
